<template>
  <TopGradientBlockLayout class="mb-12">
    <div class="text-xl font-bold text-text leading-tight mb-14">{{ $t('title') }}</div>
    <div class="grid grid-cols-10 mb-16 col-gap-12">
      <BaseSelect v-model="period" class="col-span-2"
                  :options="filters_data.period_list"
                  label="name_ru"
                  select-label="Период"
                  track-by="value"
                  :searchable="false"
                  :allow-empty="false"
                  :close-on-select="true"
                  :show-labels="false"/>
      <div class="flex flex-1 justify-end col-span-8 pt-3 space-x-16">
        <div class="flex items-center text-text-secondary text-md" v-for="(item,i) in dynamicsData.datasets">
          <div class="w-6 h-6 rounded-full mr-4" :style="{background:legendColors[i]}"></div>
          {{ item.label }}
        </div>
      </div>
    </div>
    <PortfolioDynamicsChart v-if="!dynamics.dirty" :chart-data="dynamicsData"/>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import PortfolioDynamicsChart
  from "@/components/cabinet/Investments/Dashboard/PortfolioDynamics/PortfolioDynamicsChart";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "PortfolioDynamics",
  components: {BaseSelect, PortfolioDynamicsChart, TopGradientBlockLayout},
  data() {
    return {
      legendColors: ['#00A3FF', '#27AE60']
    }
  },
  computed: {
    ...mapState('investments/portfolios', ['current_portfolio']),
    ...mapState('investments/portfolio_dynamics', ['dynamics', 'filters', 'filters_data']),
    ...mapGetters('investments/portfolio_dynamics', ['dynamicsData']),
    period: {
      get() {
        return this.filters.period
      },
      set(value) {
        this.setFilter({name: 'period', value})
        this.fetchPortfolioDynamics()
      }
    },
  },
  methods: {
    ...mapActions('investments/portfolio_dynamics', ['fetchPortfolioDynamics']),
    ...mapMutations('investments/portfolio_dynamics', ['setFilter'])
  },
  watch: {
    'current_portfolio': {
      immediate: true,
      deep: true,
      handler(val) {
        if (!!Object.keys(val.data).length) {
          this.setFilter({name: 'period', value: this.filters_data.period_list[0]})
          this.fetchPortfolioDynamics()
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Portfolio price dynamics'
      },
      ru: {
        title: 'Динамика стоимости портфеля'
      }
    }
  }
}
</script>

<style>
.chartjs-tooltip {
  opacity: 1;
  position: absolute;
  background: rgba(0, 0, 0, .7);
  color: white;
  border-radius: 3px;
  -webkit-transition: all .2s ease;
  transition: all .2s ease;
  pointer-events: none;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  white-space: nowrap;
}

.chartjs-tooltip-key {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 6px;
}
</style>